module.exports = __webpack_public_path__ + "static/scale-model-of-backbeat-tours-in-memphis-tennessee-e386f4d1838c0066239330b93e368892.png";